<template>
  <div class="hero-banner">
    <div class="img-wrap">
      <img
        v-if="!imageUrlPresent"
        :src="require(`@/assets/images/${image}`)"
        alt="Cover"
      />
      <img v-else :src="imageUrl" />
    </div>
    <h1 class="page-title">
      {{ title }}
    </h1>
  </div>
</template>

<script>
export default {
  name: "HerosBanner",
  props: {
    title: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: "recruiting-cover.jpg"
    },
    imageUrl: {
      type: String,
      default: ""
    },
    imageUrlPresent: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/_variable.scss";
.hero-banner {
  position: relative;
  min-height: 260px;
  &::before {
    content: "";
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.5);
  }
  .img-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .page-title {
    position: relative;
    z-index: 1;
    margin: 0;
    padding: 100px 0;
    text-align: center;
    font-family: $heading-font;
    color: #ffffff;
    font-weight: 400 !important;
    font-size: 66px;
    letter-spacing: 3px !important;
    text-transform: uppercase;
  }
}
@media only screen and (max-width: 991px) {
  .hero-banner {
    .page-title {
      padding: 100px 0;
      font-size: 56px;
    }
  }
}

@media only screen and (max-width: 575px) {
  .hero-banner {
    .page-title {
      padding: 80px 0;
      font-size: 48px;
    }
  }
}

@media only screen and (max-width: 425px) {
  .hero-banner {
    .page-title {
      padding: 60px 0;
      font-size: 34px;
    }
  }
}
</style>
